export default __webpack_public_path__ + "static/media/wise-logo.e11aa552.svg";